import { Header, Footer } from "./Chrome";

export const Layout = ({ children }) => (
  <div className="shell grain">
    <Header />
    <main className="site-main">{children}</main>
    <Footer />
  </div>
);
